// heavily borrowed from reselect v. 3.0.1
// with unused code removed.
// including the license for compliance:
/*
The MIT License (MIT)

Copyright (c) 2015-2018 Reselect Contributors

Permission is hereby granted, free of charge, to any person obtaining a copy
of this software and associated documentation files (the "Software"), to deal
in the Software without restriction, including without limitation the rights
to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
copies of the Software, and to permit persons to whom the Software is
furnished to do so, subject to the following conditions:

The above copyright notice and this permission notice shall be included in all
copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
SOFTWARE.
*/
const defaultEqualityCheck = (a, b) => a === b

function areArgumentsShallowlyEqual(equalityCheck, prev, next) {
  if (prev === null || next === null || prev.length !== next.length) {
    return false
  }

  const length = prev.length
  for (let i = 0; i < length; i++) {
    if (!equalityCheck(prev[i], next[i])) {
      return false
    }
  }

  return true
}

export function defaultMemoize(func, optionalEqCheck) {
  let lastArgs = null
  let lastResult = null
  return function () {
    if (
      !areArgumentsShallowlyEqual(
        optionalEqCheck || defaultEqualityCheck,
        lastArgs,
        arguments
      )
    ) {
      // apply arguments instead of spreading for performance.
      lastResult = func.apply(null, arguments)
    }

    lastArgs = arguments
    return lastResult
  }
}

function getDependencies(funcs) {
  const dependencies = Array.isArray(funcs[0]) ? funcs[0] : funcs

  if (
    !dependencies.every(function (dep) {
      return typeof dep === 'function'
    })
  ) {
    throw new Error('inputs must be funcs')
  }

  return dependencies
}

export function createSelectorCreator(memoize) {
  for (
    var len = arguments.length,
      memoizeOptions = Array(len > 1 ? len - 1 : 0),
      key = 1;
    key < len;
    key++
  ) {
    memoizeOptions[key - 1] = arguments[key]
  }

  return function () {
    for (
      var len2 = arguments.length, funcs = Array(len2), key2 = 0;
      key2 < len2;
      key2++
    ) {
      funcs[key2] = arguments[key2]
    }

    const resultFunc = funcs.pop()
    const dependencies = getDependencies(funcs)

    var memoizedResultFunc = memoize.apply(
      undefined,
      [
        function () {
          // apply arguments instead of spreading for performance.
          return resultFunc.apply(null, arguments)
        },
      ].concat(memoizeOptions)
    )

    // If a selector is called with the exact same arguments we don't need to traverse our dependencies again.
    const selector = defaultMemoize(function () {
      const params = []
      const length = dependencies.length

      for (let i = 0; i < length; i++) {
        // apply arguments instead of spreading and mutate a local list of params for performance.
        params.push(dependencies[i].apply(null, arguments))
      }

      // apply arguments instead of spreading for performance.
      return memoizedResultFunc.apply(null, params)
    })
    // @ts-ignore
    selector.resultFunc = resultFunc
    return selector
  }
}
